import { observer } from 'mobx-react-lite';

import { Box } from '@mui/material';
import GridContainer from '../components/container/GridContainer';
import DashMonitor from '../views/dashboard/DashMonitor';
import { useStore } from '../store/context';
import useMedia from '../hooks/useMedia';

const BlackboardPage = observer(() => {
  const { welcomeStore } = useStore();
  const { currentEstate } = welcomeStore;
  const isMobile = useMedia('md');

  return (
    <Box width={1}>
      <GridContainer showHeader={!!isMobile}>
        {currentEstate?.customerId && (
          <DashMonitor isMainDashboard={false} currentEstate={currentEstate} />
        )}
      </GridContainer>
    </Box>
  );
});

export default BlackboardPage;
